<template>
  <div>
    <div
      v-for="item in suborders"
      :key="`suborders-${item.pk}`"
      class="assignDepartment elevation-1"
    >
      <!-- Información del item si es suborden -->
      <v-col cols="12" sm="6" md="4">
        <p class="assignDepartment__title mb-0">{{ item.name }}</p>

        <!-- Código de la suborden -->
        <p class="assignDepartment__title">
          {{ `${$tc('code', 2)}: ` }}
          <span class="text-aux">{{ item.code }}</span>
        </p>

        <!-- Nombre del producto -->
        <div>
          <p class="assignDepartment__body mb-0">{{ $tc('product', 1) }}:</p>
          <p class="assignDepartment__text">{{ item.own_prod }}</p>
        </div>
      </v-col>

      <!-- Asignación de usuario o mensaje de alerta si no se puede asignar -->
      <v-col cols="12" sm="6" md="8">
        <select-department
          :showSelect="isProducerAssignable(item)"
          :suborder="item"
          @newDepartment="getDepartments()"
          @updateAssignDepartment="wasAssigned"
        />
      </v-col>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SelectDepartment from '@/components/department/InfoAssignDepartment.vue'

export default {
  components: {
    SelectDepartment
  },
  props: {
    suborders: {
      type: Array,
      required: true
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      company: 'company/getCompanyData'
    })
  },
  methods: {
    ...mapActions({
      showConfirmation: 'confirmation/confirmationValue'
    }),
    /**
     * Método para determinar si un productor puede ser asignado a una suborden
     * basada en el modo 'production' y el estado de la orden.
     *
     * @param {Object} item - El objeto de la suborden que contiene información
     *                        para la asignación.
     * @returns {boolean} - Devuelve verdadero si el productor puede ser
     *                      asignado, de lo contrario, devuelve falso.
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    isProducerAssignable(item) {
      const invalidOrderStatuses = [
        'design_under_review - in_wait',
        'design - in_wait',
        'design - in_design'
      ]
      const isOrderStatusInvalid = invalidOrderStatuses.includes(
        item.orderStatus
      )
      const isOrderStatusValid =
        item.orderStatus === 'design - finished' ||
        item.orderStatus === 'production - in_wait' ||
        item.orderStatus === 'production - finished'
      return !isOrderStatusInvalid && isOrderStatusValid
    },
    /**
     * Método para actualizar la información de la suborden después de asignar un departamento.
     *
     */
    wasAssigned() {
      this.$emit('updateAssignDepartment')
    }
  }
}
</script>
<style lang="sass">
.assignDepartment
  display: flex
  flex-wrap: wrap
  margin-bottom: 16px
  border-radius: 10px
  padding: 0 .5rem

.theme--light
  .assignDepartment
    background-color: rgb(0 0 0 / 3%)
    border: 1px solid rgb(0 0 0 / 0.26)
    border-left: 5px solid var(--v-primary-base)

.theme--dark
  .assignDepartment
    background-color: rgb(40 40 40)
    border: 1px solid rgb(255 255 255 / 0.16)
    border-left: 5px solid var(--v-primary-base)

.assignDepartment__title
  color: var(--v-primary-base)
  font-family: "Roboto", sans-serif
  font-size: 1.25rem
  font-weight: 900
  letter-spacing: 0.0125em
  line-height: 2rem
  @media (600px > width)
    font-size: 1rem
    letter-spacing: 0.009375em
    line-height: 1.75rem

.assignDepartment__body
  color: var(--v-primary-base)
  font-size: .9rem
  font-weight: 500
.assignDepartment__text
  font-size: 1rem
  font-weight: 400
</style>
